import React, { useState, useEffect } from "react";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { CiSearch, CiCircleCheck } from "react-icons/ci";
import { Link, useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiService from "../services/ApiService";
import { BsCircle, BsCheckCircleFill, BsCopy } from "react-icons/bs";
import PageLoader from "../components/PageLoader";
import Header from "../components/Header";

const PromotionDetails = () => {
  const { id } = useParams();
  const [isLoader, setIsLoader] = useState(false);
  const [promo, setPromo] = useState({});
  const address = JSON.parse(localStorage.getItem("address"));
  const branch = JSON.parse(localStorage.getItem("branch"));
  const type = localStorage.getItem('type') || 'delivery';
  
  // Check if this promo is already applied
  const promo_code = localStorage.getItem("promo_code");
  const searchParams = new URLSearchParams(window.location.search);
  const offer = searchParams.get('offer') || '';
  const [isAlreadyApplied, setIsAlreadyApplied] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    getPromoDetails();
  }, []);

  useEffect(() => {
    // Update isAlreadyApplied when promo data changes
    if (promo.code) {
      const isApplied = promo_code === promo.code || offer === promo.code;
      setIsAlreadyApplied(isApplied);
    }
  }, [promo.code, promo_code, offer]);
  

  const getPromoDetails = async () => {
    try {
      setIsLoader(true);
      const formData = {
        promo_id: id,
      };
      
      if(type == "delivery"){
        formData.user_address_id=address?._id;
        formData.type = "delivery";
      }else{
        formData.branch_id=branch?._id;
        formData.type = "pickup";
      }
      const response = await ApiService.request({
        method: "GET",
        url: "/getPromoDetails",
        data: formData,
      });
      const data = response.data;

      console.log(data);
      if (data.status) {
        const item=data.data;
        setPromo(item.promo);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoader(false);
    }
  };

  const moveToCart = async (promo_code) => {
    if (isAlreadyApplied) {
      // If already applied, just go to cart to show the applied promo
      navigate('/cart');
    } else {
      // Apply the new promo
      navigate('/cart?offer='+promo_code);
    }
  };

  
  return (
    <div>
      {isLoader ?(
          <PageLoader />
        ):(
      <div className="main-heading container loyality-points">
        
        <Header title={'Promotions'} />
        

        <div className="row">
          <div className="col-md-4">
                
            <div className="px-3">
              <img src={promo.image} alt="Dip Wing" className="promo-img" />
            </div>
          </div>

          <div className="col-8">
            <div className="product-details px-3">
              <p>Limited Time!</p>
              <h3 className="fw-bold">{promo.title}</h3>
              <p>{promo.description}  </p>
              <h5>Policy & Conditions</h5>
              <ul className="conditions-li mb-5 ps-0">
                {promo?.rules && promo?.rules.map((rule) => (
                <li>
                  {rule.is_eligible ?(
                    <BsCheckCircleFill className=" text-base fs-5" />
                  ):(
                    <BsCircle className=" text-base fs-5" />
                  )}
                  <span  className="ms-3">{rule.message}</span>
                </li>
                ))}
                
              </ul>
                            <div className="w-100 mx-3 redeem-btn">
                  {isAlreadyApplied && (
                    <div className="alert alert-success mb-3" role="alert">
                      <i className="bi bi-check-circle-fill me-2"></i>
                      This offer is already applied to your cart!
                      <div className="mt-2">
                        <small className="text-muted">
                          Current applied promo: <strong>{promo.code}</strong>
                        </small>
                        <div className="mt-1">
                          <small className="text-muted">
                            Go to cart to remove this promo or apply a different one
                          </small>
                        </div>
                      </div>
                    </div>
                  )}
                  <button 
                    className={`btn btn-lg py-3 fw-bold text-white ${isAlreadyApplied ? 'bg-secondary' : 'bg-success'} ${(!promo.is_eligible || isAlreadyApplied) ? 'opacity-50' : ''}`}
                    onClick={()=>moveToCart(promo.code)} 
                    disabled={!promo.is_eligible || isAlreadyApplied}
                    title={isAlreadyApplied ? 'This offer is already applied to your cart' : (!promo.is_eligible ? 'You are not eligible for this offer' : 'Click to apply this offer')}
                  >
                    {isAlreadyApplied ? (
                      <>
                        <i className="bi bi-check-circle-fill me-2"></i>
                        Applied
                      </>
                    ) : (
                      'Apply Offer'
                    )}
                  </button>
              </div>
            </div>

          </div>


        </div>

        
        
      </div>
      )};
    </div>
  );
}

export default PromotionDetails;
